import React from "react";

const STAGES = [
  { key: "downloading", label: "Downloading from storage",       pct: 33 },
  { key: "ingesting",   label: "Ingesting into knowledge base",  pct: 66 },
  { key: "done",        label: "Complete",                       pct: 100 },
];

const UploadProgressTracker = ({ fileName, status, stage, error }) => {
  const isFailed    = status === "FAILED";
  const isDone      = status === "COMPLETED";
  const isProcessing = !isFailed && !isDone;

  const stageObj   = STAGES.find((s) => s.key === stage);
  const barPct     = isDone ? 100 : (stageObj?.pct ?? 10);
  const stageLabel = stageObj?.label ?? "Starting…";

  return (
    <div className={`px-1 py-2 ${
      isDone    ? "border-green-200"  :
      isFailed  ? "border-red-200"    :
                  "border-blue-100"
    }`}>
      {/* Processing state */}
      {isProcessing && (
        <div className="space-y-1.5">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-800 flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-blue-500 animate-pulse flex-shrink-0" />
              {stageLabel}
              {fileName && (
                <span className="text-xs text-gray-400 font-normal truncate max-w-[200px]">— {fileName}</span>
              )}
            </span>
            <span className="text-xs font-semibold text-blue-500 tabular-nums flex-shrink-0 ml-3">{barPct}%</span>
          </div>
          <div className="w-full bg-blue-100 rounded-full h-1.5 overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-blue-400 to-blue-600 rounded-full transition-all duration-700 ease-out relative overflow-hidden"
              style={{ width: `${barPct}%` }}
            >
              <div
                className="absolute inset-0 rounded-full"
                style={{
                  background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)",
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.4s infinite linear",
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Completed state */}
      {isDone && (
        <div className="flex items-center gap-2 text-sm text-green-700">
          <svg className="w-4 h-4 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="font-medium">Ingestion complete</span>
          {fileName && <span className="text-green-600 text-xs">— {fileName}</span>}
        </div>
      )}

      {/* Failed state */}
      {isFailed && (
        <div className="flex items-center gap-2 text-sm text-red-700">
          <svg className="w-4 h-4 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
          <span className="font-medium">Ingestion failed</span>
          {error && <span className="text-red-600 text-xs">— {error}</span>}
        </div>
      )}

      <style>{`
        @keyframes shimmer {
          0%   { background-position: -200% 0; }
          100% { background-position:  200% 0; }
        }
      `}</style>
    </div>
  );
};

export default UploadProgressTracker;
